<ng-container
  *ngIf="{
    focusedRoiId: focusedRoiId$ | async,
    tileSource: tileSource$ | async,
    rois: rois$ | async,
    changes: changes$ | async,
    options: options$ | async,
    selectedOverlayIds: selectedOverlayIds$ | async,
    roiOverlays: roiOverlays$ | async,
    roiSizeTiles: roiSizeTiles$ | async,
    hspan: hspan$ | async
  } as state"
>
  <div
    class="crop-detail-keybindings-host"
    tsEditorKeybindings
    (ctrlMetaPressed)="multiselectionEnabled = $event"
    (shiftPressed)="dragSelectionEnabled = $event"
  >
    <div id="viewport">
      <div id="details" *ngIf="!!state.focusedRoiId || !!state.tileSource; else placeholder">
        <ts-dzi-viewer
          id="image"
          tsDziOverlaysViewer
          tsDziOverlaysEditor
          tsDziScalebar
          class="widget"
          [class.expanded]="!detailsVisible"
          *ngIf="!!state.tileSource"
          [overlays]="overlay ? state.roiOverlays : []"
          [viewerMode]="viewerMode"
          (overlaySelected)="filterByRoiIds($event)"
          [tileSource]="state.tileSource"
          [focusPoint]="centerPoint"
          [zoomLevel]="zoomLevel"
          [hspan]="state.hspan"
          position="BOTTOM_CENTER"
          (zoomLevelChanged)="zoomLevel = $event"
          (focusPointChanged)="centerPoint = $event"
        ></ts-dzi-viewer>

        <mat-paginator
          *ngIf="state.selectedOverlayIds?.size > 0"
          class="widget pagination-row"
          [length]="state.selectedOverlayIds.size"
          [pageSize]="1"
          [hidePageSize]="true"
          [showFirstLastButtons]="true"
          (page)="onRegionChange($event, state.selectedOverlayIds)"
          aria-label="Select region"
        ></mat-paginator>

        <div class="detail-sections" *ngIf="detailsVisible && !!state.focusedRoiId">
          <div class="size-tiles" *ngIf="state.roiSizeTiles?.length">
            <div class="size-tile" *ngFor="let tile of state.roiSizeTiles">
              <span class="size-tile-label">{{ tile.labelKey | translate }}</span>
              <span class="size-tile-value">{{ tile.main }}</span>
              <span class="size-tile-secondary" *ngIf="tile.secondary">{{ tile.secondary }}</span>
            </div>
          </div>

          <div class="detail-section" *ngIf="state.rois[state.focusedRoiId]?.labels as focusedRoiLabels">
            <div class="detail-section-header">
              <span class="detail-section-title">{{ 'analysis.labels_title' | translate }}</span>
            </div>
            <div class="label-item" *ngFor="let label of focusedRoiLabels.keys()">
              <ng-container
                *ngIf="{
                  value: formatPercentage(focusedRoiLabels.get(label)),
                  name: state.options[label]?.name ?? label ?? '???'
                } as data"
              >
                <span class="label-name">{{ data.name }}</span>
                <div class="bar-container">
                  <div class="bar" [ngStyle]="{ width: data.value }"></div>
                </div>
                <span class="label-value">{{ data.value }}</span>
              </ng-container>
            </div>
          </div>

          <div class="detail-section" *ngIf="state.changes.get(state.focusedRoiId) as focusedRoiChanges">
            <div class="detail-section-header">
              <span class="detail-section-title">{{ 'analysis.changes_title' | translate }}</span>
              <button
                mat-icon-button
                class="revert-button"
                [disabled]="!editingEnabled"
                (click)="revertRoiChanges(state.focusedRoiId)"
              >
                <i class="ri-arrow-go-back-line"></i>
              </button>
            </div>

            <div class="change-chips">
              <ng-container *ngFor="let label of focusedRoiChanges.labelsAdded">
                <span class="change-chip added" *ngIf="state.options[label] as label">+ {{ label.name }}</span>
              </ng-container>

              <ng-container *ngFor="let label of focusedRoiChanges.labelsRemoved">
                <span class="change-chip removed" *ngIf="state.options[label] as label">− {{ label.name }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #placeholder>
    <div id="no-data-warning">
      <p class="word-wrap">{{ 'mosaic.no_crop_selected' | translate }}</p>
    </div>
  </ng-template>
</ng-container>
